import type { Image as TImage } from "@m10s/search-frontend-clients/quest";

export type Image = Pick<TImage, "aspect_ratio" | "height" | "path" | "url" | "width">;

const DEFAULT_RATIO = 1;

enum RatioClassNames {
	LANDSCAPE = "aspect-4/3",
	PORTRAIT = "aspect-3/4",
	SQUARE = "aspect-1/1",
}

type AspectRatioOptions = {
	defaultRatio?: number;
};

export function getAspectRatio({ aspect_ratio, height, width }: Partial<Image>, options?: AspectRatioOptions): string {
	const { defaultRatio = DEFAULT_RATIO } = options ?? {};
	const ratio: number = computeAspectRatio(aspect_ratio, height, width) ?? defaultRatio;
	if (ratio >= 1.29) {
		return RatioClassNames.LANDSCAPE;
	} else if (ratio <= 0.76) {
		return RatioClassNames.PORTRAIT;
	} else {
		return RatioClassNames.SQUARE;
	}
}

export function computeAspectRatio(ratio?: number, height?: number, width?: number): number | null {
	if (ratio && ratio > 0) {
		return ratio;
	} else if (width && height && width > 0 && height > 0) {
		return width / height;
	} else {
		return null;
	}
}
